import React from 'react';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from './Loader';

interface PrimaryFixedBulkActionManuProps {
  className?: string;
  items: Map<string, any>;
  purchasedBooksNumber: number;
  close?: () => void;
  printDisabled?: boolean;
  printLoader?: boolean;
  shipLoader?: boolean;
  onPrint?: () => void;
  onShip?: () => void;
}

const PrimaryFixedBulkActionManu: React.FC<PrimaryFixedBulkActionManuProps> = ({
  className,
  items,
  purchasedBooksNumber,
  close,
  printDisabled,
  printLoader,
  shipLoader,
  onPrint,
  onShip,
}: PrimaryFixedBulkActionManuProps) => {
  const isPrintDisabled = !!printDisabled || !!printLoader || +items?.size <= 0;

  return (
    <div className={`fixed bottom-20 left-0 right-0 m-auto flex flex-col items-center justify-center z-30`}>
      <div
        className={`relative flex justify-between flex-col items-center bg-white shadow-md w-full md:w-auto rounded-3xl ${className || ''}`}
      >
        <div className={`relative flex justify-between items-center px-8 py-6`}>
          <div className="mr-4 md:mr-16">
            <span>{+items?.size} Selected</span>
          </div>
          <div className="flex items-center gap-6">
            <button
              type="button"
              disabled={isPrintDisabled}
              className={`relative text-secondaryStoryAdditionalLightBlueText bg-transparent border border-secondaryStoryAdditionalLightBlueText rounded-2xl hover:shadow-md pl-2 pr-4 py-2 text-sm font-bold flex items-center h-9 ${
                isPrintDisabled ? 'opacity-50 cursor-not-allowed hover:shadow-none' : ''
              }`}
              onClick={() => !isPrintDisabled && onPrint && onPrint()}
              title="Generate post-session flyers"
            >
              <img
                src="/printer_icon_transparent.png"
                alt="print"
                className="text-xl text-storyblue p-2 cursor-pointer w-10 h-10"
              />
              Generate Flyers
              {printLoader && <Loader loader={true} className={'absolute right-0'} dimentions={'w-9 h-9'} />}
            </button>
            {onShip && (
              <button
                className="text-secondaryStoryAdditionalLightBlueText bg-transparent border border-secondaryStoryAdditionalLightBlueText rounded-2xl hover:shadow-md pl-2 pr-4 py-2 text-sm font-bold flex items-center h-9"
                onClick={() => onShip && onShip()}
                title="Ship selected book"
              >
                <img
                  src="/box_icon_transparent.png"
                  alt="print"
                  className="text-xl text-storyblue p-2 cursor-pointer w-10 h-10"
                />
                Ship stories
                {shipLoader && <Loader loader={shipLoader} dimentions={'w-9 h-9'} className={'px-3'} />}
              </button>
            )}
          </div>
          <FontAwesomeIcon
            icon={faClose}
            title="Close selection mode"
            onClick={close}
            className="mr-4 md:ml-16 text-xl text-storyblue p-2 cursor-pointer"
          />
        </div>
        <div className="flex justify-start w-full px-8 py-3 border-t">
          <span className="text-storyblue mr-4 md:mr-14">Students with Purchased Books – {purchasedBooksNumber}</span>
        </div>
      </div>
    </div>
  );
};
export default PrimaryFixedBulkActionManu;
